import { useCallback } from "react";
import { ApolloError, FetchResult } from "@apollo/client";
import {
  useUpdateCart,
  UpdateCartData,
  UpdateCartProps,
} from "src/hooks/useUpdateCart";
import { CartInfo } from "src/types/cartInfo";

interface SetCartCustomerEmailHook {
  data?: UpdateCartData;
  loading: boolean;
  error?: ApolloError;
  setCartCustomerEmail: (
    email: string,
    cartInfo: CartInfo
  ) => Promise<FetchResult<UpdateCartData> | undefined>;
}

function useSetCartCustomerEmail({
  refetchQueries = [],
  onCompleted,
  onError,
}: UpdateCartProps = {}): SetCartCustomerEmailHook {
  const { updateCart, data, loading, error } = useUpdateCart({
    refetchQueries,
    onCompleted,
    onError,
  });

  const setCartCustomerEmail: SetCartCustomerEmailHook["setCartCustomerEmail"] =
    useCallback(
      async (email, cartInfo) => {
        if (!email || !cartInfo?.id) {
          return;
        }

        return await updateCart({
          cartInfo,
          actions: [
            {
              setCustomerEmail: {
                email,
              },
            },
          ],
        });
      },
      [updateCart]
    );

  return { setCartCustomerEmail, data, loading, error };
}

export { useSetCartCustomerEmail };
